import { Pipe, PipeTransform } from '@angular/core';
import { DecimalPipe } from "@angular/common";

@Pipe({
  name: 'formattaImporto'
})
export class FormattaImportoPipe implements PipeTransform {

  transform(value: string): string {
    if (value) {
      // value.replace(',', 'v');
      let arrConfig = [[',', 'v'], ['.', ','], ['v', '.']];
      const reduced = arrConfig.reduce((acc: string, config) => {
      return  acc.replace(config[0], config[1])
      }, value);
      return reduced
    }
    return '';
  }

}
